<template>
  <div class="balance-content">
    <div class="top">
      <span>
        {{
          ReplaceText(
            "XXX",
            pointAccountName,
            TLang("CardTips", "orderConfirm")
          )
        }}
      </span>
      <i
        class="el-input__icon el-icon-arrow-up rotate-180"
        :class="showStatus ? 'is-reverse' : ''"
        @click="changeShow()"
      ></i>
      <span v-if="deductionMoney" class="tip">
        {{ TLang("抵扣", "card") }}
        <span class="red">{{ deductionMoney }}</span
        >{{ pointAccountUnitName }}</span
      >
    </div>
    <div v-show="showStatus" class="bottom">
      <div class="use-select">
        <span
          :class="{ 'use-tab': true, active: type === '0' }"
          @click="
            () => {
              type = '0';
              sendGio('福利卡', '可用卡');
            }
          "
          >{{ TLang("可用", "orderConfirm") }}({{ usableBalanceInfo.length || 0 }})</span
        >
        <span
          :class="{ 'use-tab': true, 'un-use-tab': true, active: type === '1' }"
          @click="
            () => {
              type = '1';
              sendGio('福利卡', '不可用卡');
            }
          "
          >{{ TLang("不可用", "orderConfirm") }}({{
            unavailableBalanceInfo.length
          }})</span
        >
      </div>
      <div v-if="type === '0'" class="usableWrap">
        <ul v-if="usableBalanceInfo.length">
          <li
            v-for="(item, index) in usableBalanceInfo"
            :key="index"
            class="balance-item"
            :class="[item.checked === 'Y' ? 'sel-border' : 'noSel-border',{'no-click':!enable}]"
            @click="enable && changeStatus(index, item)"
          >
            <img
              v-show="item.checked === 'Y'"
              :src="require('@assets/images/group_sel.png')"
              class="sel-image"
            />
            <p class="name" :class="{'en-font':!enable}">
              {{ `${TLang("可用余额", "orderConfirm")}(${item.pointAccountUnitName || TLang("福豆", "orderConfirm")})` }}
            </p>
            <p class="cardBalance" :class="{'en-font':!enable}">
              {{ formatBalance(item.showBalance)[0]
              }}<em>.{{ formatBalance(item.showBalance)[1] }}</em>
            </p>
            <!-- <p class="due">
              {{ `有效期至:${item.expiredTime}` }}
            </p> -->
          </li>
        </ul>
        <div v-else class="empty-data">
          {{ TLang("暂无可用余额", "card") }}
        </div>
      </div>
      <div v-else class="unavailableWrap">
        <ul v-if="unavailableBalanceInfo.length">
          <li
            v-for="(item, index) in unavailableBalanceInfo"
            :key="index"
            class="balance-item"
            :class="[{'no-click':!enable}]"
          >
            <div class="unUsedBalanceInfo">
              <div class="balanceName">{{item.pointAccountName}}</div>
              <div class="balanceTxt">
                {{ TLang("可用余额", "orderConfirm") }}({{ item.pointAccountUnitName || TLang( "福豆", "orderConfirm") }})
              </div>
              <div class="cardBalance">
                {{ formatBalance(item.showBalance)[0] }}<em>.{{ formatBalance(item.showBalance)[1] }}</em>
              </div>
              <div class="balanceTime" :class="{'font-red': item.thirtyDayExpire}" v-if="item.expiredTime">
                {{ `${item.expiredTime}` }}{{ TLang("过期", "orderConfirm") }}
              </div>
              <div class="balanceRange">
                <div class="balanceNo">{{ TLang("账号", "orderConfirm") }}:{{ item.cardKindId }}</div>
                <span class="balanceTips">
                  <el-popover
                    popper-class="useScope"
                    placement="bottom-start"
                    title=""
                    max-width="300"
                    trigger="hover"
                    :content="item.desc"
                  >
                    <el-button slot="reference">
                      <img :src="require('@/assets/images/order/tips.png')" />
                      <em class="tipTxt">&nbsp;{{ TLang("使用范围", "orderConfirm") }}</em>
                    </el-button>
                  </el-popover>
                </span>
              </div>
            </div>
            <div class="disableReason" v-if="item.unavailableDesc">
              <img :src="require('@/assets/images/icon_deliver_tip.png')" />{{
                item.unavailableDesc
              }}
            </div>
          </li>
        </ul>
        <div v-else class="empty-data">
          {{ TLang("暂无不可用余额", "card") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Toast from "@components/simpleToast";
import { payTotastNames } from "@utils/config";
export default {
  name: "BalanceList",
  props: {
    interestsInfo: Object,
    sendGio: Function,
  },
  data() {
    const { balanceInfo } = this.interestsInfo;
    return {
      // 工会账户余额为0，默认进来是收起状态
      showStatus: balanceInfo && +balanceInfo.usableMoney > 0,
      enable: balanceInfo && +balanceInfo.usableMoney > 0,
      balanceInfo:JSON.parse(JSON.stringify(this.interestsInfo)),
      type: "0",
    };
  },
  computed: {
    // 账户余额名称
    pointAccountName() {
      return (
        (this.balanceInfo && this.balanceInfo.balanceInfo &&
          this.balanceInfo.balanceInfo.pointAccountName) ||
        this.TLang("账户余额", "orderConfirm")
      );
    },
    // 单位名称
    pointAccountUnitName() {
      return (
        (this.balanceInfo && this.balanceInfo.balanceInfo &&
          this.balanceInfo.balanceInfo.pointAccountUnitName) ||
        this.TLang("福豆", "card")
      );
    },
    // 账户余额抵扣总金额
    deductionMoney() {
      if (
        this.balanceInfo.balanceInfo &&
        this.balanceInfo.balanceInfo.deductionMoney
      ) {
        return Number(
          (this.balanceInfo.balanceInfo.deductionMoney * window.union_scale) /
            100
        ).toFixed(2);
      }
      return "";
    },
    // 可用余额
    usableBalanceInfo() {
      if (
        this.balanceInfo.balanceInfo &&
        this.balanceInfo.balanceInfo.usableBalanceInfo &&
        this.balanceInfo.balanceInfo.usableBalanceInfo.length
      ) {
        return this.balanceInfo.balanceInfo.usableBalanceInfo;
      }
      return [];
    },
    // 不可用余额
    unavailableBalanceInfo() {
      if (
        this.balanceInfo.balanceInfo &&
        this.balanceInfo.balanceInfo.unavailableBalanceInfo &&
        this.balanceInfo.balanceInfo.unavailableBalanceInfo.length
      ) {
        return this.balanceInfo.balanceInfo.unavailableBalanceInfo;
      }
      return [];
    },
  },
  watch: {
    interestsInfo: {
      handler(val) {
        this.balanceInfo = JSON.parse(JSON.stringify(val));
        // this.handleData();
      },
      deep: true,
    },
  },
  created() {
    // this.handleData();
  },
  methods: {
    changeStatus(index, item) {
      var allCard = this.$parent.allSelectCard;
      if (this.usableBalanceInfo[index].checked === "Y") {
        this.$props.sendGio("账户余额", "选择可用余额", {
          status: "取消勾选",
          contentTitle: item.pointName,
        });
        this.usableBalanceInfo[index].checked = "N";
        let count = allCard.balanceCards.findIndex(
          (obj) => obj.cardNo === item.cardKindId
        );
        if (count > -1) {
          allCard.balanceCards.splice(count, 1);
        }
      } else {
        if (!this.$parent.enableSelect) {
          Toast.info(payTotastNames.noRemainPay, 1.5);
          return;
        }
        this.$props.sendGio("账户余额", "选择可用余额", {
          status: "勾选",
          contentTitle: item.pointName,
        });
        let obj = {};
        obj.cardNo = item.cardKindId;
        obj.value = item.checkedValue;
        this.usableBalanceInfo[index].checked = "Y";
        let count = allCard.balanceCards.findIndex(
          (per) => per.cardNo === item.cardKindId
        );
        if (count > -1) {
          allCard.balanceCards.splice(count, 1, obj);
        } else {
          allCard.balanceCards.push(obj);
        }
      }
      allCard.chooseType = 3;
      this.$emit("func", allCard);
    },
    changeShow() {
      this.showStatus = !this.showStatus;
    },
    formatBalance(balance) {
      // console.log("balance", balance);
      if (!balance) {
        return ["0", "00"];
      }
      const newBalance = Number((balance * window.union_scale) / 100).toFixed(
        2
      );
      return newBalance.split(".");
    },
  },
};
</script>
<style lang="less" scoped>
.transition {
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

.rotate(@rotateDegree) {
  color: #111;
  font-size: 22px;
  font-weight: 700;
  -webkit-transform: rotateZ(@rotateDegree);
  transform: rotateZ(@rotateDegree);
  cursor: pointer;
  .transition;
}
.cardBalance {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3d96e2;
  em {
    font-size: 12px;
  }
}

.rotate-180 {
  .rotate(180deg);
}
.is-reverse {
  -webkit-transform: rotateZ(0);
  transform: rotateZ(0);
}
.balance-content {
  padding: 24px 0 0 24px;
}
.top {
  font-size: 20px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #111111;
  margin-bottom: 14px;
  .tip {
    margin-left: 32px;
    color: #333;
    font-size: 14px;
    font-weight: 400;
    .red {
      color: #f44545;
    }
  }
}
.use-select {
  width: 260px;
  height: 25px;
  margin-bottom: 12px;
  .use-tab {
    position: relative;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
    cursor: pointer;
  }
  .un-use-tab {
    margin-left: 30px;
  }
  .active {
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #3d96e2;
  }
  .active:after {
    content: "";
    width: 35px;
    height: 2px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -4px;
    background: linear-gradient(202deg, #5cb4ec 0%, #3d96e2 100%);
    border-radius: 3px;
  }
}
.sel-border {
  border: 2px solid #3d96e2;
}
.noSel-border {
  border: 1px solid #e5e5e5;
}
.empty-data {
  width: 100%;
  height: 60px;
  text-align: center;
  padding-top: 30px;
  font-size: 14px;
  color: #333;
}
.no-click{
  background: #F6F6F7 !important;
  // color: #333;
}
.en-font{
  color: #333 !important;
}
.usableWrap {
  ul {
    display: flex;
    flex-wrap: wrap;
    .balance-item {
      box-sizing: border-box;
      width: 270px !important;
      margin-bottom: 24px;
      margin-right: 24px;
      background: #f8fcff;
      // padding-left: 12px;
      // padding-top: 12px;
      padding: 12px 0 12px 12px;
      // border: 1px solid #e5e5e5;
      position: relative;
      .sel-image {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 0;
        right: 0;
      }
      .jifen {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #111111;
        //   margin-top: -4px;
        margin-bottom: 3px;
      }
      .name {
        font-size: 12px;
        font-weight: 400;
        color: #3d96e2;
      }
      .amount {
        font-size: 12px;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #3d96e2;
      }
      .due {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #666666;
        margin-top: 8px;
      }
    }
    .balance-item:nth-child(4n) {
      margin-right: 0;
    }
  }
}
.unavailableWrap {
  ul {
    display: flex;
    flex-wrap: wrap;
    .balance-item {
      box-sizing: border-box;
      width: 270px !important;
      margin-bottom: 24px;
      margin-right: 24px;
      position: relative;
      .unUsedBalanceInfo {
        padding: 12px;
        border: 1px solid #e5e5e5;
        box-sizing: border-box;
        background: #f8fcff;
        background: #f6f6f7;
      }
      .unUsedCard:nth-child(4n) {
        margin-right: 0;
      }
      .balanceName {
        max-height: 42px;
        font-size: 16px;
        line-height: 21px;
        font-family: MicrosoftYaHei;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
      .balanceTxt {
        padding-top: 12px;
        font-size: 12px;
        line-height: 17px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
      }
      .cardBalance {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333;
        height: 33px;
        em {
          font-size: 12px;
        }
      }
      .balanceNo {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #666666;
        line-height: 16px;
      }
      .balanceRange {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #666;
        padding-top: 12px;
        align-items: center;
      }
      .balanceTime {
        text-align: left;
        padding-top: 12px;
        color: #666;
        line-height: 16px;
      }
      .font-red {
        color: #F44545;
      }
      .balanceTips {
        text-align: right;
        img {
          margin-right: -2px;
          width: 12px;
          height: 12px;
          vertical-align: middle;
          margin-top: -1.8px;
        }
        .tipTxt {
          color: #999;
          cursor: pointer;
          font-size: 12px;
        }
      }
      .disableReason {
        padding: 4px 12px;
        background: #f6f6f7;
        border: 1px solid #e5e5e5;
        border-top: none;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f44545;
        img {
          width: 12px;
          height: 12px;
          padding-right: 5px;
          vertical-align: baseline;
        }
      }
    }
    .balance-item:nth-child(4n) {
      margin-right: 0;
    }
  }
}
</style>

